import { PaginationParams, SearchingProps } from 'modules/Shared/type';
import Family from 'modules/Family/model/Family';

export interface FamilyListState extends SearchingProps {
  families: Family[];
  fetching: boolean;
  totalPages: number;
  pagination: PaginationParams;
}

export const initFamilyListState = (): FamilyListState => ({
  families: [],
  pagination: {
    page: 1,
    count: 100
  },
  totalPages: 1,
  filter: {},
  sort: {},
  fetching: false
});
